import React, { useMemo } from "react";
import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter
} from "@stadium/ui/src/components/ModalNew/utils";
import { InternalButton } from "@sharedComponents/buttons";
import ProductCarousel from "@components/store/product-detail/shared/product-detail-carousel";
import styles from "./main.module.scss";

const SaveBoxAlert = ({ product, onConfirm, onReject }) => {
  const sliderImages = useMemo(
    () =>
      product.variantImages
        ? product.variantImages?.map((image, index) => {
            return { id: `image${index}`, image };
          })
        : [{ id: `image${product.id}`, image: product.baseImage }],
    [product]
  );

  return (
    <Modal newModal mobileBottomDrawer>
      <ModalDialog>
        <ModalContent>
          <ModalHeader>
            <div className={styles.modalTitle}>If you exit now, your box won't be saved </div>
            <CloseButton onClick={onReject} className={`${styles.closeIcon}`} />
          </ModalHeader>
          <ModalBody>
            <article className={styles.modalBodyContent}>
              <div className={styles.productCarousalWrapper}>
                <ProductCarousel sliderImages={sliderImages} />
              </div>
            </article>
            <div className={styles.infoText}>Finish your box and add it to bag to save your selections.</div>
          </ModalBody>
          <ModalFooter className={styles.modalFooter}>
            <InternalButton onClick={onConfirm} className={styles.exitBtn} styleType="primary-outline">
              Exit
            </InternalButton>
            <InternalButton onClick={onReject} className={styles.finishBox} styleType="primary">
              finish box
            </InternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default SaveBoxAlert;
